export type BadgeSample = {
  id: string;
  label: string;
  bgClass: string;
  hoverBgClass: string;
  hoverTextClass: string;
};

export type ButtonSample = {
  id: string;
  label: string;
  variant: "default" | "secondary" | "dark" | "destructive" | "outline" | "ghost" | "link";
};

export const badgeSamples: BadgeSample[] = [
  {
    id: "B.1.1",
    label: "PROTOCOL V1.0",
    bgClass: "bg-white",
    hoverBgClass: "hover:bg-[#3B82F6]",
    hoverTextClass: "hover:text-white",
  },
  {
    id: "B.1.2",
    label: "NEW FEATURE",
    bgClass: "bg-[#A3E635]",
    hoverBgClass: "hover:bg-[#6366F1]",
    hoverTextClass: "hover:text-white",
  },
];

export const buttonSamples: ButtonSample[] = [
  { id: "B.2.1", label: "PRIMARY", variant: "default" },
  { id: "B.2.2", label: "SECONDARY", variant: "secondary" },
  { id: "B.2.3", label: "DARK", variant: "dark" },
  { id: "B.2.4", label: "DESTRUCTIVE", variant: "destructive" },
  { id: "B.2.5", label: "OUTLINE", variant: "outline" },
  { id: "B.2.6", label: "GHOST", variant: "ghost" },
  { id: "B.2.7", label: "LINK (Pure Text)", variant: "link" },
];
